import { Image as SemanticImage } from 'semantic-ui-react';

export { ImageProps, StrictImageProps } from 'semantic-ui-react';

export const Image: typeof SemanticImage = SemanticImage;

export default Image;
